import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

// info at: https://fontawesome.com/how-to-use/on-the-web/using-with/react
// icon list at: https://fontawesome.com/cheatsheet/free/regular
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faCheckSquare as fasCheckSquare,
    faSquare as fasSquare,
    faStopCircle as fasStopCircle,
    faPlayCircle as fasPlayCircle,
    faPauseCircle as fasPauseCircle,
    faFile as fasFile,
    faFolder as fasFolder,
    faFolderOpen as fasFolderOpen,
    faSave as fasSave,
    faMusic as fasMusic,
    faCaretDown as fasCaretDown,
    faCog as fasCog,
    faSearch as fasSearch,
    faTimesCircle as fasTimesCircle,
    faPlus as fasPlus,
    faMinus as fasMinus,
} from '@fortawesome/free-solid-svg-icons';
import {
    faCheckSquare as farCheckSquare,
    faSquare as farSquare,
    faStopCircle as farStopCircle,
    faPlayCircle as farPlayCircle,
    faPauseCircle as farPauseCircle,
    faFile as farFile,
    faFolder as farFolder,
    faFolderOpen as farFolderOpen,
    faSave as farSave,
    faTimesCircle as farTimesCircle,
} from '@fortawesome/free-regular-svg-icons';

const IconContainer = styled.div`
    display: block;
`;

const MIN_OPACITY = 0.65;

function jsonConcat(o1, o2) {
    for (var key in o2) {
        o1[key] = o2[key];
    }
    return o1;
}

library.add(
    fasCheckSquare, farCheckSquare,
    fasSquare, farSquare,
    fasStopCircle, farStopCircle,
    fasPlayCircle, farPlayCircle,
    fasPauseCircle, farPauseCircle,
    fasFile, farFile,
    fasFolder, farFolder,
    fasFolderOpen, farFolderOpen,
    fasSave, farSave,
    fasMusic,
    fasCaretDown,
    fasCog,
    fasSearch,
    fasTimesCircle, farTimesCircle,
    fasPlus, fasMinus
);

export class UtilIcon extends Component {

    static propTypes = {
        icon: PropTypes.string.isRequired,
        relSize: PropTypes.string,
        absSize: PropTypes.string,
        fixedWidth: PropTypes.bool,
        inverse: PropTypes.bool,
        rotation: PropTypes.number,
        flip: PropTypes.bool,
        spin: PropTypes.bool,
        pulse: PropTypes.bool,
        border: PropTypes.bool,
        solid: PropTypes.bool,
        color: PropTypes.string,
        bgColor: PropTypes.string,
        style: PropTypes.object,
        id: PropTypes.string,
        className: PropTypes.string,
        hover: PropTypes.bool,
        hover_min: PropTypes.number,
        hidden: PropTypes.bool
    }

    static defaultProps = {
        hover_min: MIN_OPACITY
    }

    state = {
        in_hover: false
    }

    hover(e, state) {
        this.setState({in_hover: state});
    }

    simple_icon(
        is_solid = this.props.solid,
        color = this.props.color ? this.props.color : "black",
        style = {},
        className = this.props.className || '',
        id = this.props.id || this.random_id()) {
        if (this.props.absSize) {
            style.fontSize = this.props.absSize;
        }
        if (this.props.hidden) {
            style.display = 'none';
        }
        if (!this.props.bgColor && !this.state.in_hover) {
            style.opacity = this.props.hover_min;
        }
        const solid = is_solid ? 'fas' : 'far';
        style = jsonConcat(style, this.props.style || {});
        return <FontAwesomeIcon
            icon={[solid, this.props.icon]}
            fixedWidth={this.props.fixedWidth}
            inverse={this.props.inverse}
            flip={this.props.flip}
            spin={this.props.spin}
            pulse={this.props.pulse}
            border={this.props.border}
            rotation={this.props.rotation}
            size={this.props.relSize}
            color={color}
            style={style}
            id={id}
            className={className}
        />
    }

    random_id() {
        return 'id_' + Math.floor(Math.random() * 100000);
    }

    two_tone_icon() {
        const id = this.props.id || this.random_id();
        const bg_id = id + '_background';

        const outline_style = {
            width: this.props.absSize,
            opacity: 1.0
        };
        const background_style = {
            left: '-' + this.props.absSize,
            right: this.props.absSize,
            width: this.props.absSize,
            opacity: !this.props.hover ? 1.0 : (this.state.in_hover ? 1.0 : this.props.hover_min)
        };
        const outline = this.simple_icon(false, this.props.color, outline_style, "two_toned_foreground_icon", id)
        const background = this.simple_icon(true, this.props.bgColor, background_style, "two_toned_background_icon", bg_id)
        const container_style = {marginRight: '-' + this.props.absSize}
        return <div style={container_style}>
            {outline}
            {background}
        </div>
    }

    render() {
        const icon = (!this.props.solid && this.props.bgColor) ? this.two_tone_icon() : this.simple_icon();
        return <IconContainer
            onMouseOver={(e) => this.hover(e, true)}
            onMouseOut={(e) => this.hover(e, false)}>
            {icon}
        </IconContainer>
    }
}

export default UtilIcon;
